export default "__VITE_ASSET__CKRN_H2E__"